export class Periode {

// tslint:disable-next-line: max-line-length
// tslint:disable-next-line: indent
	constructor(id, ordre, libelle, duree, duree_jour, duree_nuit, nightbreak_duree, intervalle_arrosage, id_recette) {
        this.id = id;
        this.ordre = ordre;
        this.libelle = libelle;
        this.duree = duree;
        this.duree_jour = duree_jour;
        this.duree_nuit = duree_nuit;
        this.nightbreak_duree = nightbreak_duree;
        this.intervalle_arrosage = intervalle_arrosage;
        this.id_recette = id_recette;
    }

    public id: number;
    public libelle: string;
    public ordre: number;
    public duree: number;
    public duree_jour: number;
    public duree_nuit: number;
    public nightbreak_duree: number;
    public intervalle_arrosage: number;
    public id_recette: number;


}